export default function TermsAndConditionsPage() {
    return (
        <section className="py-16 sm:py-18">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <h1 className="text-4xl font-semibold text-blue-900 sm:text-5xl mb-8">Kompetisies
                    Terms and Conditions
                </h1>

                <p className="mt-4 text-lg/8 text-gray-600">
                    Below are the standard terms and conditions applicable to all competitions conducted/promoted partly
                    or wholly by, or associated with, KOSMOS 94.1.</p>
                <ol className="list-decimal list-inside mt-4 space-y-2">
                    <li>No person may enter the same or any other competition hosted partly or in whole by KOSMOS 94.1
                        within 90 days of winning the same or any other competition hosted partly or in whole by KOSMOS
                        94.1.
                    </li>
                    <li>No person may, on behalf of a third party, enter any competition hosted partly or in whole by
                        KOSMOS 94.1. All entries must be made personally by the entrant.
                    </li>
                    <li>The judges’ decision is final, and no correspondence will be entered into.</li>
                    <li>No director of COSMOS DIGITAL NAMIBIA LIMITED, employee at KOSMOS 94.1 and/or their agencies,
                        and members of their immediate family; nor members of the sponsors of any competition on KOSMOS
                        94.1, and/or any of their affiliated companies and/or agencies, and members of their immediate
                        family, may enter any of the competitions hosted partly or in whole by KOSMOS 94.1.
                    </li>
                    <li>Prizes are non-transferable and are not negotiable.</li>
                    <li>All prizes must be collected at the registered offices of KOSMOS 94.1 in Windhoek, at own
                        cost.
                    </li>
                    <li>Prizes not collected/claimed within 60 days of being won will be disposed of at KOSMOS 94.1’s
                        discretion.
                    </li>
                    <li>Winners of specific competitions accept that certain other conditions may apply as prescribed by
                        KOSMOS 94.1 and/or the respective sponsor of the specific competition. Where there are specific
                        terms and conditions, in addition to these standard terms and conditions, such terms and
                        conditions shall be listed under the terms and conditions of the specific competition.
                    </li>
                    <li>Any violation or attempt to violate any of the above rules will result in the immediate
                        disqualification of the transgressor.
                    </li>
                    <li>Entrants below the age of 18 (eighteen) should obtain their parents’ or guardian’s consent
                        before entering the competition.
                    </li>
                    <li>By participating in any competition hosted partly or in whole by KOSMOS 94.1, where entry is
                        online, participants further agree to be bound by our Internet Terms & Conditions.
                    </li>
                </ol>

                <h5 className="text-xl font-semibold text-blue-900 sm:text-xl my-8">IMPORTANT NOTICE</h5>
                <p className="mt-4 text-lg/8 text-gray-600">
                    Beware of bogus callers & SMS notifications that say you’ve won with KOSMOS 94.1. Here’s how you can
                    check for bogus notifications:
                </p>
                <ol className="list-decimal list-inside mt-4 space-y-2">
                    <li>You will NEVER be contacted by SMS if you are a winner.</li>
                    <li>Unless pre-arranged with you, KOSMOS 94.1 representatives will NEVER come to your office or home
                        to say you’re a winner or to deliver a prize.
                    </li>
                    <li>The ONLY prize collection-point from KOSMOS 94.1 is the registered offices of KOSMOS 94.1.
                        Please NEVER agree to collect a prize from ANYWHERE else. Under exceptional circumstances and
                        with management approval, prizes will be couriered to winners who live outside of a 50km radius
                        of the KOSMOS 94.1 offices at the winner’s expense.
                    </li>
                    <li>If anyone contacts you to say you’ve won a prize in a KOSMOS 94.1 competition, make sure you
                        entered it! If anyone calls to say you’ve won a competition you never entered with KOSMOS 94.1,
                        it is NOT one of our representatives.
                    </li>
                    <li>Our representatives will be able to quote you your ID number. If in ANY doubt, ask the caller
                        for their name and the KOSMOS 94.1 switchboard number and phone the caller back. Any number
                        other than 061 255 985 means the caller is trying to trick you.
                    </li>
                    <li>If you are concerned that a bogus caller has contacted you, please store the number of the
                        caller (if you have caller ID) and email it to info@kosmos.com.na
                    </li>
                </ol>
            </div>
        </section>
    );
}